export const getMessageFromError = (e: any) => {
  let errorMessage: string = '';

  if (!e) {
    return errorMessage;
  }

  if (typeof e === 'string') {
    errorMessage = e;
  } else if ('message' in e) {
    errorMessage = e.message;
  } else if ('errors' in e && Array.isArray(e.errors)) {
    errorMessage = e.errors?.[0]?.message ?? '';
  }

  return errorMessage;
};
